const e = [
  "1x",
  "2x",
  "4x",
  "add-new",
  "add-panel",
  "add-reaction",
  "add-to-report",
  "admin-shield-safe",
  "alias-alt",
  "alias-protected",
  "apps",
  "area",
  "artifact-type-alt",
  "artifact-type",
  "attachment",
  "audio-volume",
  "automation-robot-arm",
  "back",
  "baseline-alt",
  "bell-notifications",
  "benchmark-square",
  "blog-alt",
  "blog-report",
  "bold",
  "book-dictionary",
  "bookmark-my-projects",
  "box-plot",
  "branch-commit",
  "bug",
  "bulk-panel-alt",
  "buzz-bot",
  "buzz-bot10",
  "buzz-bot4",
  "buzz-bot7",
  "buzz-bot8",
  "camera-photo",
  "caret-close",
  "caret-open",
  "category-multimodal",
  "chart-area-alt2",
  "chart-area-percentage",
  "chart-horizontal-bars",
  "chart-line",
  "chart-pie",
  "chart-scatterplot",
  "chart-vertical-bars",
  "checkmark-alt",
  "checkmark-circle",
  "checkmark",
  "checkmark2",
  "chevron-back",
  "chevron-down",
  "chevron-next",
  "chevron-up",
  "circle",
  "clear-all",
  "close",
  "cloud-upload",
  "code-alt",
  "collapse",
  "color-palette",
  "color",
  "column-alt",
  "column",
  "combine",
  "compass-baseline-alt",
  "compass-baseline",
  "condition",
  "content-full-width",
  "content-narrow",
  "content-wide",
  "context-window",
  "copy",
  "cost",
  "credit-card-payment",
  "crop-beginning",
  "crop-end",
  "crop-middle",
  "cross",
  "crown-pro",
  "cube-container",
  "dashboard-blackboard",
  "database-artifacts",
  "date",
  "delete",
  "desktop-responsive",
  "diamond-pro",
  "diamond",
  "diff",
  "discord-social",
  "do-not-prohibited",
  "doc-left",
  "document",
  "documentation",
  "download",
  "draft-manual",
  "drag-grip",
  "education-academic",
  "ema-exponential",
  "email-at",
  "email-envelope",
  "enter-return",
  "enter-switch",
  "enterprise-corporate",
  "expand-down",
  "expand-left",
  "expand-right",
  "expand-uncollapse",
  "expand-up",
  "export-share-upload",
  "extract-break",
  "extract",
  "facebook-social",
  "failed-error-deleted",
  "feather-alt",
  "feather",
  "filled-circle",
  "filter-alt",
  "flash-bolt",
  "folder-fill",
  "folder-project-move",
  "folder-project",
  "forum-chat-bubble",
  "forward-next",
  "freeze-snowflake-alt",
  "freeze-snowflake",
  "full-screen-mode-expand",
  "ghost-agent",
  "git",
  "github",
  "group",
  "hand-manual",
  "hashtag",
  "headset",
  "heart-filled",
  "heart",
  "help-alt",
  "help-resources",
  "history",
  "home",
  "hourglass-alt",
  "hourglass",
  "idle",
  "ignore-outliers",
  "impersonate-mask-alt",
  "impersonate-mask",
  "import-insert",
  "inference",
  "infinity-auto",
  "info",
  "isolate",
  "italic",
  "job-automation",
  "job-calculator",
  "job-program-code",
  "key-admin-private",
  "key-admin",
  "keyboard",
  "languages",
  "laptop-local-computer",
  "layout-grid",
  "layout-horizontal",
  "layout-mixed",
  "layout-split",
  "layout-tabs",
  "layout-vertical",
  "lightboard",
  "lightbulb-info",
  "line-plot-1",
  "line-plot-alt2",
  "line-plot",
  "linear-scale-1",
  "linear-scale",
  "link-alt",
  "list-bullets-outlined",
  "list-bullets",
  "list-numbered",
  "listing",
  "loading",
  "location-pin",
  "lock-closed",
  "lock-open",
  "locked-constrained",
  "loess",
  "log-in",
  "log-out",
  "log-scale-x",
  "log-scale-y",
  "logarithmic",
  "magic-wand-star",
  "magic-wand-stick",
  "marker",
  "megaphone",
  "menu",
  "microphone-audio",
  "miller-columns",
  "minimize-mode",
  "mobile-responsive",
  "model",
  "moon",
  "multi-select",
  "music-audio",
  "new-section-above",
  "new-section-below",
  "open-new-tab",
  "orchestration-launch",
  "organization-corporate",
  "overflow-horizontal",
  "pan-tool-1",
  "pan-tool",
  "panel-auto-gen",
  "panel-manual",
  "panel",
  "paragraph",
  "parent-back-up",
  "pause",
  "paused",
  "pencil-edit",
  "phone",
  "photo-picture",
  "pin-filled",
  "pin",
  "play",
  "privacy-open",
  "privacy-team-private",
  "privacy-team-public",
  "privacy-user-private",
  "privacy-user-public",
  "queue",
  "queued",
  "quickstart-code",
  "randomize-alt",
  "recent-clock",
  "reddit-social",
  "redo",
  "regex",
  "registries",
  "reload-refresh",
  "remove-alt",
  "remove",
  "report",
  "reset",
  "retry-swap",
  "robot-service-member",
  "rocket-launch",
  "rowheight-l",
  "rowheight-m",
  "rowheight-s",
  "rowheight-xl",
  "run-set-subset",
  "run-set-universe",
  "running-repeat",
  "sandobx-playground",
  "save",
  "scale-up",
  "search",
  "section",
  "seed-propagate",
  "select-marquee-tool",
  "select-move-tool",
  "settings-parameters",
  "settings",
  "shield-protected",
  "shield-remove",
  "smoothing",
  "sort-ascending",
  "sort-descending",
  "sort-direction",
  "sort",
  "spiral",
  "split",
  "square",
  "star-filled",
  "star",
  "stop",
  "stopped",
  "strikethrough",
  "sun",
  "sweep-bayes",
  "sweep-grid",
  "sweep-random-search",
  "sweeps-alt",
  "sweeps-broom",
  "switch-account",
  "system-chip-alt",
  "system-chip",
  "system",
  "table",
  "tablet-responsive",
  "tag",
  "text-language-alt",
  "text-language",
  "thumbs-down",
  "thumbs-up",
  "time-weighted-ema",
  "token",
  "treeview",
  "triangle-down",
  "triangle-left",
  "triangle-right",
  "triangle-up",
  "type-boolean",
  "type-number-alt",
  "type-number-alt2",
  "type-number",
  "type-string-alt",
  "type-string-quote",
  "unassigned-01",
  "unassigned-02",
  "undo",
  "unlocked-unconstrained",
  "up-post",
  "user-author",
  "user-profile-personal",
  "users-team",
  "uuid-identifier",
  "versions-layers",
  "video-play",
  "view-alt",
  "view-glasses",
  "wandb",
  "warning",
  "weave-group-board",
  "weave",
  "webhook-alt",
  "webhook",
  "wrap",
  "x-axi-alt",
  "x-axis",
  "x-social",
  "youtube-social",
  "zoom-alt-tool",
  "zoom-in-tool",
  "zoom-out-tool"
], a = [
  "checkbox-checked",
  "checkbox-unchecked",
  "checkbox-indeterminate",
  "radio-checked",
  "radio-unchecked",
  "visible",
  "not-visible",
  "visibility-indeterminate"
], t = [
  "amazon-sagemaker",
  "bokeh",
  "colab",
  "docker-whale",
  "keras",
  "kubernetes",
  "molecule",
  "plotly",
  "python",
  "pytorch-lightning",
  "pytorch",
  "scikit",
  "slack",
  "tensorflow",
  "vertex-gcp"
];
export {
  a as FORM_ICONS,
  e as ICONS,
  t as LOGO_ICONS
};
//# sourceMappingURL=constants.js.map
